export enum ERoutes {
    login = '/signin',
    thirdPartyLogin = '/externalsignin',
    loginConsumer = '/signin/consumer',
    loginExternal = '/signin/external',
    loginFacebook = '/signin/facebook',
    facebookAddPassword = '/facebookloginsetpassword',
    facebookAddPasswordSuccess = '/facebookloginsetpassword/success',
    logout = '/signout',
    logoutSuccess = '/signout/success',
    error = '/error',
    forgotPassword = '/forgotpassword',
    forgotPasswordStaff = '/staffforgotpassword',
    terms = '/terms',
    consent = '/consent',
    resetPassword = '/resetpassword',
    resetPasswordStaff = '/staffresetpassword',
    register = '/register',
    registerConfirm = '/register/confirm',
    verify = '/verify',
    verifyStaff = '/staffverify',
    unverified = '/unverified',
    unverifiedStaff = '/staffunverified',
    changeEmail = '/changeemail',
    changeEmailStaff = '/staffchangeemail',
    createAccount = '/createaccount',
    createAccountEmail = '/createaccount/email',
    createAccountConfirm = '/createaccount/confirm',
    createAccountSuccess = '/createaccount/success',
    createFamilyAccount = '/createfamilyaccount',
    createFamilyAccountManualLinkUser = '/createfamilyaccount/linkuser',
    createFamilyAccountConfirm = '/createfamilyaccount/confirm',
    createFamilyAccountSuccess = '/createfamilyaccount/success',
    migrateAccount = '/updateaccount',
    migrateAccountVerify = '/updateaccount/verify',
    migrateAccountSuccess = '/updateaccount/success',
    staffMigrateAccount = '/staffupdateaccount',
    staffMigrateAccountPassword = '/staffupdateaccount/password',
    staffMigrateAccountVerify = '/staffupdateaccount/verify',
    staffMigrateAccountSuccess = '/staffupdateaccount/success',
    migrateToExistingAccount = '/existingaccount',
    migrateToExistingAccountSuccess = '/existingaccount/success',
    graduateUser = '/setupaccount',
    graduateUserSuccess = '/setupaccount/success',
    confirmAccount = '/confirmaccount',
    confirmAccountPickOwner = '/confirmaccount/owner',
    confirmAccountDetails = '/confirmaccount/info',
    confirmAccountSuccess = '/confirmaccount/success',
    confirmAccountStaff = '/staffonboarding',
    confirmAccountStaffExists = '/staffonboarding/exists',
    confirmAccountStaffDetails = '/staffonboarding/info',
    confirmAccountStaffPhone = '/staffonboarding/phone',
    confirmAccountStaffPhoneVerify = '/staffonboarding/phoneverify',
    confirmAccountStaffSuccess = '/staffonboarding/success',
    confirmAccountStaffExpired = '/staffonboarding/expired',
    multiFactorAuth = '/multifactorauth',
    multiFactorAuthValidate = '/multifactorauth/validate',
    multiFactorAuthRecovery = '/multifactorauth/recovery',
    multiFactorAuthDisable = '/multifactorauth/disable',
}

export enum ELinks {
    privacyPolicy = 'https://co.mindbodyonline.com/legal/privacy-policy',
    termsServiceConsumer = 'https://co.mindbodyonline.com/legal/consumer-agreement',
    termsServiceStaff = 'https://co.mindbodyonline.com/legal/terms-of-service',
    loginFacebook = '/external/challenge?provider=Facebook',
    loginGoogle = '/external/challenge?provider=Google',
    loginApple = '/external/challenge?provider=Apple',
    loginAzureAd = '/external/challenge?provider=AzureAd',
    connectAuthorize = '/connect/authorize',
    userPortal = 'https://account.mindbodyonline.com',
    mindbodyAppAndroid = 'https://play.google.com/store/apps/details?id=com.mindbodyonline.express',
    mindbodyAppIos = 'https://apps.apple.com/us/app/mindbody-business/id599125654',
    adminLogin = '/SiteLogin',
    manualMigrationArticle = 'https://support.mindbody.io/s/article/How-to-resolve-the-error-message-This-login-is-no-longer-supported-View-the-Migration-Guide-for-steps-to-reconnect-to-your-account?language=en_US',
    cantAccessEmailArticle = 'https://support.mindbody.io/s/article/I-already-have-an-account#What-if-I-cant-access-my-email',
}

export enum EAppEnvironment {
    devLocal = 'http://localhost:3000',
    local = 'https://localhost:5000',
    ngrok = 'ngrok.io',
    staging = 'https://signin.staging.arcusplatform.io',
    devSandbox = 'https://signin-sandbox.staging.arcusplatform.io',
    production = 'https://signin.mindbodyonline.com',
}

export enum EQueryStringParam {
    returnUrl = 'ReturnUrl',
    returnUrlCamelCase = 'returnUrl',
    redirectUri = 'redirect_uri',
    subscriberId = 'subscriberId',
    studioId = 'studioId',
    staff = 'staff',
    handoffScreen = 'screen',
    error = 'error',
    userId = 'userId',
    code = 'code',
    clientId = 'client_id',
    linkId = 'linkId',
    customerAccountName = 'customerAccountName',
    customerAccountId = 'customerAccountId',
    retry = 'retry',
    loginHint = 'login_hint',
    logoutId = 'logoutId',
    email = 'email',
    provider = 'provider',
    surface = 'surface',
}

export enum EConnectBaseUrl {
    dev = 'https://dev-connect.mbodev.me',
    production = 'https://connect.mindbodyonline.com',
}

export enum EWebClientsBaseUrl {
    dev = 'https://dev.mbodev.me',
    production = 'https://clients.mindbodyonline.com',
}

export enum ERestAPIBaseUrl {
    dev = 'https://dev-rest.mbodev.me',
    production = 'https://api.mindbodyonline.com',
}

export enum EAdminBaseUrl {
    dev = 'https://admin.mbodev.me',
    production = 'https://admin.mindbodyonline.com',
}

export enum EStaffAccountType {
    subscriber,
    account,
}

export enum EFamilyAccountType {
    none = 'none',
    firstParty = 'firstParty',
    thirdParty = 'thirdParty',
    confirmAccount = 'confirmAccount',
}

export enum ERouterStateParams {
    familyAccountType = 'familyAccountType',
    primaryUser = 'primaryUser',
}

export enum EThirdPartyProvider {
    facebook = 'Facebook',
    google = 'Google',
    apple = 'Apple',
}

export const maxFamilyItems = 5;

export const maxNameLength = 100;

export const maxEmailLength = 255;

export const maxStaffFirstNameLength = 100;

export const maxStaffLastNameLength = 50;

export const delayLoginMilliseconds = 2000;

export enum ELDFlags {
    staffIdentity = 'identityStaff',
    consumerIdentity = 'identityConsumer',
    useConsumerPasscodeVerification = 'consumerIdentityUsePasscode',
    mixPanelPoc = 'mixpanelPoc',
    newConsumerIdentity = 'newConsumerIdentity',
    deprecateFacebook = 'deprecateFacebook',
    removeFacebook = 'removeFacebook',
}

export enum EIdentityClientId {
    webClients = 'Mindbody.Web.Clients',
    devPortal = 'Mindbody.Web.DeveloperPortal',
    devCommunity = 'Mindbody.DeveloperCommunity',
    iosExpress = 'Mindbody.Api.Public.IOSExpress.Legacy',
    androidExpress = 'Mindbody.Api.Public.AndroidExpress.Legacy',
    test = 'test.client',
    brandedWeb = 'Mindbody.BrandedWeb.Legacy',
    messengerAi = 'Mindbody.Messenger.Bff',
    mindbodyAppIos = 'Mindbody.ConnectApp.iOS',
    mindbodyAppAndroid = 'Mindbody.ConnectApp.Android',
    mindbodyMarketplace = 'ConsumerMarketplace.ExploreApp',
}

export const mbEmailDomain = 'mindbodyonline.com';

export const noNameAvailable = 'N/A';

export enum EPhoneNumberVerificationType {
    text = 'sms',
    call = 'call',
}

export enum EPromiseResolution {
    fulfilled = 'fulfilled',
    rejected = 'rejected',
}

export const loginLinkLocalStorageKey = 'mb.identity.loginLink';

export const loginLinkTtlMinutes = 10;

export const autoLoginSeconds = 60;

export const toasterDurationMilliseconds = 5000;

export enum EUnsupportedReason {
    unsupportedBrowser,
    cookiesDisabled,
}

export enum EUserType {
    staff = 'staff',
    consumer = 'consumer',
}

export enum EValidHandoffScreens {
    createAccount = 'createaccount',
}

export enum EMixpanelEnvId {
    dev = '4a29ba44b6813ca6b7ff0247f804c589',
    production = '38489367533689072d7cce494fc6aa7b',
}

export enum EMixpanelAppName {
    identity = 'identity',
    brandedWeb = 'branded_web',
    messengerAi = 'messenger_ai',
    mindbodyApp = 'mindbody_app',
    mindbodyMarketplace = 'mindbody_web',
}

export enum EMixpanelEvent {
    viewed = 'viewed',
    interacted = 'interacted',
    actionStart = 'action_started',
    actionCompleted = 'action_completed',
    actionCanceled = 'action_canceled',
    actionFailed = 'action_failed',
}

export const mixpanelEntryPointWhitelist = [ERoutes.loginExternal];

export const facebookDeprecationDate = 'July 15th 2025';

// source of truth https://github.com/bowser-js/bowser/blob/master/src/constants.js
export enum EBrowserOS {
    WindowsPhone = 'Windows Phone',
    Windows = 'Windows',
    MacOS = 'macOS',
    iOS = 'iOS',
    Android = 'Android',
    WebOS = 'WebOS',
    BlackBerry = 'BlackBerry',
    Bada = 'Bada',
    Tizen = 'Tizen',
    Linux = 'Linux',
    ChromeOS = 'Chrome OS',
    PlayStation4 = 'PlayStation 4',
    Roku = 'Roku',
}
